import { memo } from 'react';
import clsx from 'clsx';
import { Checkbox } from '@headlessui/react';

import { SelectOption } from '~/shared/utils/types';
import Tag from '~/shared/components/Tag';
import CheckIcon from '~/shared/assets/icons/check.svg';

interface SearchFilterOptionRowProps {
  option: SelectOption;
  isSelected: boolean;
  onSelect: (option: SelectOption) => void;
  onHover?: () => void;
  className?: string;
  tagVariant?: 'cluster' | 'instance' | 'volume' | 'default';
}

const SearchFilterOptionRow = memo(function SearchFilterOptionRow({
  option,
  isSelected,
  onSelect,
  onHover,
  className,
  tagVariant = 'default',
}: SearchFilterOptionRowProps) {
  return (
    <div
      key={option.id}
      className={clsx('py-1 my-[12px]  rounded-md transition-colors flex items-center', className)}
      onClick={() => onSelect(option)}
      onMouseEnter={onHover}
    >
      <div className="mr-3">
        <Checkbox
          checked={isSelected}
          onClick={(e) => {
            e.stopPropagation();
            onSelect(option);
          }}
          className="group block size-5 p-[4px] rounded-md border border-primary-100 bg-white data-checked:bg-primary-500 ring:0 active:ring-primary-300 focus:ring-primary-500 cursor-pointer"
        >
          <CheckIcon className="text-white stroke-2 size-2.5 opacity-0 group-data-checked:opacity-100 transition duration-200 ease-in-out" />
        </Checkbox>
      </div>

      <Tag
        variant={tagVariant}
        size="md"
        text={option.name}
        className="cursor-pointer"
        showFullText={true}
      />
    </div>
  );
});

export default SearchFilterOptionRow;
